import { useEffect, useState } from 'react';
import './ContactCss/Contact.css';
import Fail from './Fail';
import Success from './Success';
import Agree from './Agree';
import emailjs from 'emailjs-com';

function Contact(){

    const [val, setVal] = useState('');
    const [check, setCheck] = useState(0);

    const [inputValue, setInputValue] = useState({
        name : '',
        validName : false,
        phone : '',
        validPhone : false,
        email : '',
        validEmail : false,
        content : '',
        validContent : false
    })

    const submitRequirements = inputValue.name &&
                                inputValue.validName &&
                                inputValue.phone &&
                                inputValue.validPhone &&
                                inputValue.email &&
                                inputValue.validEmail &&
                                inputValue.content &&
                                inputValue.validContent &&
                                (check === 1);

    useEffect(() => {
        const nameRegex = /^[ㄱ-ㅎ가-힣a-zA-Z0-9]{1,20}$/;        
        setInputValue(prev => ({ ...prev, validName: nameRegex.test(inputValue.name) }));
    }, [inputValue.name]);

    useEffect(() => {
        const phoneRegex = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
        setInputValue(prev => ({ ...prev, validPhone: phoneRegex.test(inputValue.phone) }));
    }, [inputValue.phone]);

    useEffect(() => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
        setInputValue(prev => ({ ...prev, validEmail: emailRegex.test(inputValue.email) }));
    }, [inputValue.email]);

    useEffect(() => {
        const contentRegex = /[\s\S]/g;
        setInputValue(prev => ({ ...prev, validContent : contentRegex.test(inputValue.content)}));
    }, [inputValue.content])

    const Validation = () => {
        if(!submitRequirements){
            setVal('실패');
            return false;
        }else{
            setVal('성공');
            return true;
        }
    }

    const [isEmailSent, setIsEmailSent] = useState(false);
    const sendVerificationEmail = () => {
        const templateParams = {
            to_name : '기보',
            to_email : 'vendrick0526@gmail.com',
            from_name : inputValue.name + '이메일 : ' + inputValue.email + ' 연락처 : ' + inputValue.phone,
            message : inputValue.content
        };

        emailjs
            .send(
                'Mail-Service',
                'Inquire',
                templateParams,
                process.env.REACT_APP_EMAIL_API
            )
            .then((response) => {
                console.log('이메일이 성공적으로 보내졌습니다:', response);
                setIsEmailSent(true);
            })
            .catch((error) => {
                console.error('이메일 보내기 실패:', error);
            });
    };

    return(
        <>
        
        <div className='wrapper'>
            <div className="contact-home">
                <div className="contact-body">
                        <div className='title-body'>
                            <div className='title-body-left'>
                                <div className='title-input'>
                                    <input className={'inputbox' + (inputValue.validName === true ? 'confirm' : '')} type='text' value={inputValue.name} placeholder='업체명(성함)' onChange={(e)=>{setInputValue({...inputValue, name:e.target.value})}}></input>
                                </div>
                                <div className='title-input'>
                                    <input className={'inputbox' + (inputValue.validPhone === true ? 'confirm' : '')} type='text' value={inputValue.phone} placeholder='연락처(휴대전화)' onChange={(e)=>{setInputValue({...inputValue, phone:e.target.value})}}></input>                                    
                                </div>
                                <div className='title-input'>
                                    <input className={'inputbox' + (inputValue.validEmail === true ? 'confirm' : '')} type='text' value={inputValue.email} placeholder='이메일' onChange={(e)=>{setInputValue({...inputValue, email:e.target.value})}}></input>
                                </div>
                            </div>
                            <div className='title-body-right'>
                                <div className='con-input'>
                                    <textarea className={'conbox' + (inputValue.validContent === true ? 'confirm' : '')} type='text' value={inputValue.content} placeholder='문의내용' onChange={(e)=>{setInputValue({...inputValue, content:e.target.value})}}></textarea>
                                </div>
                            </div>
                        </div>
                        <div className='contact-button'>
                            <button className={"keep-button" + (check === 1 ? 'able' : '')} onClick={()=>{check === 0 ? setCheck(1) : setCheck(0)}}>
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 6.65217L5.58333 11L12 1" stroke="#fff" stroke-width="1.5"></path></svg>
                            </button>
                            <label className='label' onClick={()=>check === 0 ? setCheck(1) : setCheck(0)}>개인정보 수집 및 이용 동의</label>
                            <p className='agree' onClick={()=>{setVal('전문')}}>전문보기</p>
                            <div className='submit' onClick={()=>{if(Validation()){sendVerificationEmail();}}}>문의하기</div>
                        </div>
                </div>
            </div>
        </div>
        {
            val === '실패' ? <Fail val={val} setVal={setVal}></Fail> : val === '성공' ? <Success val={val} setVal={setVal}></Success> : val === '전문' ? <Agree val={val} setVal={setVal}></Agree> : null
        }
        </>
    )
}

export default Contact;